import { useQuery } from "@tanstack/react-query";

import { ActivityComment } from "../../../pages/organization/project/tab-activities/dialogs/types/activityDTO";
import { readActivitiesAnnotation } from "../../../services/activities";

type TUseReadProjectActivityAnnotation = {
    activityId: string;
};

export type TResponseActivityComments = {
    data: ActivityComment[];
};

export function useReadProjectActivityAnnotation({
    activityId,
}: TUseReadProjectActivityAnnotation) {
    return useQuery<
        TResponseActivityComments,
        unknown,
        TResponseActivityComments
    >({
        enabled: true,
        queryKey: [`readAnnotationActivity`],
        queryFn: () => readActivitiesAnnotation({ activityId }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
    });
}
